/**
 * modules
 */

import preloader from '../../../templates/_atoms/preloader/_script';
// import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';
import imageSlider from '../../../templates/_organisms/imageSlider/_script';
import appHeader from '../../../templates/_organisms/appHeader/_script';
import pageTitle from '../../../templates/_molecules/pageTitle/_script';
import imageGallery from '../../../templates/_organisms/imageGallery/_script';
import cards from '../../../templates/_organisms/cards/_script';
import accordion from '../../../templates/_organisms/accordion/_script';
import announcement from '../../../templates/_atoms/announcement/_script';
// import travelMap from '../../../templates/_molecules/travelMap/_script';
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
const modulesArray = [
    preloader,
    appHeader,
    pageTitle,
    // codeSnippet,
    imageSlider,
    imageGallery,
    accordion,
    announcement,
    cards,
    // travelMap,
    // cookiebar,
    // imageGallery,
    // navCategories
];

const modules = {
    // Modules
    Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach((module) => {
                module.init();
            });
        }
    },

    init() {
        this.Modules();
    }
};

export default modules;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/modules.js